<template>
    <!-- 電腦版卡片詳情頁面 -->
    <div class="row gap-5">
        <div class="col-md-4 card"> 
            <div class="card-body">
                <div>
                    <img src="@/assets/images/driver/small-card.png" class="small-card-img" alt="card-detail" />
                </div>
                <div class="card-number"> {{ cardStore.cardInfo?.external_account_id }}</div>
                <div class="left-text">Balance</div>
                <div class="card-balance-amount">${{ cardStore.cardInfo?.balance  }}</div>
                <div class="left-text">{{ cardClosed?'':'Verification' }} status</div>
                <div v-if="cardStore.cardInfo?.status === 'closed'" class="card-verification-status status-blocked"> <img src="@/assets/svg/alert.svg " alt="close-card" style="margin-right:10px">Card Closed</div>
                <div v-else-if="cardStore.cardInfo?.is_compliant==true" class="card-verification-status status-verified">Verified</div>
                <div v-else-if="cardStore.cardInfo?.is_compliant==false && cardStore.cardInfo?.balance<1000" class="card-verification-status status-blocked">
                    Unverified
                    <div class="mt-3 unverified-text">
                        Once your card balance exceeds $1,000, it will be temporarily blocked until ID verification is completed. 
                       
                    </div>
                    <div class="mt-3 unverified-text">
                      Verification usually completes automatically within minutes. If manual verification is needed, you'll receive an SMS with a secure link to finish the process.
                    </div>
                    <!-- <div class="mt-3 d-flex">
                        <button class="btn btn-verify">Verify card now</button>
                        <div class="external-link">(External link)</div>
                    </div> -->
                </div>
                <div v-else-if="cardStore.cardInfo?.is_compliant==false && cardStore.cardInfo?.balance>=1000" class="card-verification-status status-blocked">
                  <img src="@/assets/svg/alert.svg">  
                  Card blocked 
                    <div class="card-verification-status status-blocked">
                      Verification required
                    </div> 
                    <div class="mt-3 unverified-text">
                        Once your card balance exceeds $1,000, it will be temporarily blocked until ID verification is completed. 
                       
                    </div>
                    <div class="mt-3 unverified-text">
                      Verification usually completes automatically within minutes. If manual verification is needed, you'll receive an SMS with a secure link to finish the process.
                    </div>
                    <!-- <div class="mt-3 d-flex">
                        <button class="btn btn-verify">Verify card now</button>
                        <div class="external-link">(External link)</div>
                    </div> -->
                </div>
                <hr v-if="!cardClosed">
                <div v-if="!cardClosed">
                    <div class="switch-row">
                        <div class="custom-switch-group" >
                            <label class="custom-switch">
                                <input type="checkbox" :checked="lockCard" @change="onSwitch('lock', $event)" :disabled="showPopover || isLockCardDisabled">
                                <span class="custom-slider" :class="{ checked: lockCard }"></span>
                            </label>
                            <span class="switch-label">Temporarily lock card</span>
                            <div v-if="showPopover && popoverType === 'lock'" class="switch-popover-mask" @click.self="cancelSwitch">
                                <div class="switch-popover" ref="popoverRef" tabindex="0">
                                    <div class="popover-content">
                                        <div class="popover-title">Are you sure you want to temporarily lock this card?</div>
                                        <div class="popover-desc">This will temporarily disable all transactions, you can unlock it anytime.</div>
                                        <div class="popover-actions">
                                            <button class="btn-link text-secondary" @click="cancelSwitch">Cancel</button>
                                            <button class="btn-link text-primary" @click="confirmSwitch">YES</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 解鎖卡片時的提示窗 -->
                            <div v-if="showPopover && popoverType === 'unlock'" class="switch-popover-mask" @click.self="cancelSwitch">
                                <div class="switch-popover" ref="popoverRef" tabindex="0">
                                    <div class="popover-content">
                                        <div class="popover-title">Are you sure you want unlock this card?</div>
                                        <div class="popover-desc">Your card will be active again and ready to use for all transactions.</div>
                                        <div class="popover-actions">
                                            <button class="btn-link text-secondary" @click="cancelSwitch">Cancel</button>
                                            <button class="btn-link text-primary" @click="confirmSwitch">YES</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="custom-switch-group">
                            <label class="custom-switch">
                                <input type="checkbox" :checked="deactivateCard" @change="onSwitch('deactivate', $event)" :disabled="showPopover || isLostStolenDisabled">
                                <span class="custom-slider" :class="{ checked: deactivateCard }"></span>
                            </label>
                            <span class="switch-label"> Lost / stolen</span>
                            <!-- 標記為 lost/stolen 時的提示窗（開關關閉，要開啟） -->
                            <div v-if="showPopover && popoverType === 'deactivate'" class="switch-popover-mask" @click.self="cancelSwitch">
                                <div class="switch-popover" ref="popoverRef" tabindex="0">
                                  <div class="popover-content">
                                        <div class="popover-title">Are you sure you want to mark the card as lost or stolen?</div>
                                        <div class="popover-desc">
                                            <p>This will temporarily disable all transactions to keep your card secure.</p>
                                            <p>If you find your card, you can unlock it here as well.</p>
                                            <p>If the card cannot be recovered, contact customer service to arrange a replacement – a $15 reissue fee will apply.</p>
                                        </div>
                                        <div class="popover-actions">
                                            <button class="btn-link text-secondary" @click="cancelSwitch">Cancel</button>
                                            <button class="btn-link text-primary" @click="confirmSwitch">YES</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 移除 lost/stolen 狀態時的提示窗（開關已開啟，要關閉） -->
                            <div v-if="showPopover && popoverType === 'remove-lost-stolen'" class="switch-popover-mask" @click.self="cancelSwitch">
                                <div class="switch-popover" ref="popoverRef" tabindex="0">
                                  <div class="popover-content">
                                        <div class="popover-title">Are you sure you want to remove the lost / stolen status?</div>
                                        <div class="popover-desc">Your card will be active again and ready to use for all transactions.</div>
                                        <div class="popover-actions">
                                            <button class="btn-link text-secondary" @click="cancelSwitch">Cancel</button>
                                            <button class="btn-link text-primary" @click="confirmSwitch">YES</button>
                                        </div>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="mt-3 d-flex" v-if="!cardClosed">
                        <button class="btn btn-verify w-100" @click="changPin">Change PIN</button>
                        <div class="external-link w-100">(External link)</div>
                    </div>
                    <div v-else>
                      <button class="btn btn-Apply-new-card w-120">Apply for a new card</button>
                    </div>
                
                <hr v-if="!cardClosed">
                
                <div class="deactivate-cancel-container" v-if="!cardClosed">
                    <button  class="btn-deactivate-cancel" @click="showDeactivatePopover" :disabled="cardStatus === 'closed'">Deactivate / cancel card</button>
                    <div v-if="showPopover && popoverType === 'deactivate-cancel'" class="switch-popover-mask deactivate-popover-mask" @click.self="cancelSwitch">
                        <div class="switch-popover" ref="popoverRef" tabindex="0">
                            <div class="popover-content">
                                <div class="popover-title">Are you sure you want to deactivate this card?</div>
                                <div class="popover-desc">Once deactivated, this card will be permanently blocked.Any remaining balance will be forfeited</div>
                                <div class="popover-desc">If you would like to be issued with a new card, please submit a new application– note that a $15 card reissuing fee applies.</div>
                                <div class="popover-actions">
                                    <button class="btn-link text-secondary" @click="cancelSwitch">Cancel</button>
                                    <button class="btn-link text-primary" @click="confirmDeactivateCancel">YES</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-7 card">
            <div class="card-body">
                <div class="transaction-history">
                    <h4 class="transaction-title">Transaction history</h4>
                    <p class="transaction-note">You can view transaction history from the past 180 days.</p>
                    
                    <div class="search-section">
                        <div class="date-filters">
                            <div class="filter-group">
                                <label for="from-date">From</label>
                                <div class="input-group">
                                <Datepicker1 
                                    class="datepicker-here form-control digits" 
                                    v-model="dateFrom" 
                                    :format="'dd/MM/yyyy'" 
                                    :time-picker="false" 
                                    :max-date="maxDate"
                                    :min-date="minDate"
                                    data-language="en" 
                                    placeholder="Select date" 
                                />
                                </div>
                            </div>
                            <div class="filter-group">
                                <label for="to-date">To</label>
                                <div class="input-group">
                                    <Datepicker1 
                                        class="datepicker-here form-control digits" 
                                        v-model="dateTo" 
                                        :format="'dd/MM/yyyy'" 
                                        :time-picker="false" 
                                        :max-date="maxDate"
                                        :min-date="minDate"
                                        data-language="en" 
                                        placeholder="Select date" 
                                    />
                                </div>
                            </div>
                        </div>
                        <button class="search-btn" @click="searchTransactions(1)">Search</button>
                    </div>
                    
                    <div class="table-container">
                        <table class="transaction-table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Description</th>
                                    <th>Money in</th>
                                    <th>Money out</th>
                                    <!-- <th>Balance</th> -->
                                    <th class="info-col">Info</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="transactions.length === 0">
                                    <td colspan="5" class="no-transactions">
                                        <p>No transactions found for the selected date range.</p>
                                    </td>
                                </tr>
                                <tr v-for="transaction in transactions" :key="transaction.id">
                                    <td>{{ transaction.date }}</td>
                                    <!-- <td>{{ transaction.description }}</td> -->
                                     <td>{{ transaction.card_acceptor_location }}</td>
                                    <td class="money-in">{{ transaction.moneyIn ? `$${transaction.moneyIn}` : '' }}</td>
                                    <td class="money-out">{{ transaction.moneyOut ? `-$${transaction.moneyOut}` : '' }}</td>
                                    <!-- <td>{{ `$${transaction.balance}` }}</td> -->
                                    <td class="info-col">
                                        <button type="button" class="transaction-info-btn" @click="openTransactionDetail(transaction)" aria-label="Transaction info">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        
                    </div>
                    
                    
                </div>
            </div>
           <!-- 分頁控制項 - 移到表格下方 -->
           <div v-if="paginationMeta.total_pages > 0 && paginationMeta.total_items > 0" class="pagination-container">
                        <div class="pagination-controls">
                            <!-- 第一頁按鈕 -->
                            <button 
                                @click="goToPage(1)" 
                                :disabled="currentPage === 1"
                                class="pagination-btn"
                                title="第一頁"
                            >
                                <img src="@/assets/images/icon/End arrow Mobile.png" alt="End arrow Mobile" class="arrow-icon rotate-180">
                            </button>
                            
                            <!-- 上一頁按鈕 -->
                            <button 
                                @click="goToPage(currentPage - 1)" 
                                :disabled="currentPage === 1"
                                class="pagination-btn"
                                title="上一頁"
                            >
                                <img src="@/assets/images/icon/next.png" alt="next" class="arrow-icon rotate-180" style="width:16px;height:16px;">
                            </button>
                            
                            <!-- 頁碼輸入 -->
                            <div class="page-input-container">
                                <span class="page-label">Page</span>
                                <input 
                                    v-model.number="pageInput" 
                                    @keyup.enter="goToPage(pageInput)"
                                    @blur="goToPage(pageInput)"
                                    type="number" 
                                    :min="1" 
                                    :max="paginationMeta.total_pages"
                                    class="page-input"
                                />
                                <span class="page-total">of {{ paginationMeta.total_pages }}</span>
                            </div>
                            
                            <!-- 下一頁按鈕 -->
                            <button 
                                @click="goToPage(currentPage + 1)" 
                                :disabled="currentPage === paginationMeta.total_pages"
                                class="pagination-btn"
                                title="下一頁"
                            >
                                <img src="@/assets/images/icon/next.png" alt="next" class="arrow-icon" style="width:16px;height:16px;">
                            </button>
                            
                            <!-- 最後一頁按鈕 -->
                            <button 
                                @click="goToPage(paginationMeta.total_pages)" 
                                :disabled="currentPage === paginationMeta.total_pages"
                                class="pagination-btn"
                                title="最後一頁"
                            >
                                <img src="@/assets/images/icon/End arrow Mobile.png" alt="End arrow Mobile" class="arrow-icon">
                            </button>
                        </div>
                        
                        <!-- 顯示項目範圍 -->
                        <div class="pagination-info">
                            Displaying {{ pagination.startItem }} – {{ pagination.endItem }} of {{ pagination.totalItems }}
                        </div>
                    
                    
                    </div>
        </div>
        
    </div>
    <div v-if="showKycModal" class="kyc-modal-mask" @click.self="closeKycModal">
        <div class="kyc-modal">
            <div class="kyc-modal-title">
                <img src="@/assets/svg/alert.svg" alt="alert" class="kyc-alert-icon">
                Verification Required
            </div>
            <div class="kyc-modal-text">
                We couldn't complete your identity verification automatically.
            </div>
            <div class="kyc-modal-text">
                Please complete manual KYC verification using the link below:
            </div>
            <a
                v-if="kycVerificationLink"
                class="kyc-modal-link"
                :href="kycVerificationLink"
                target="_blank"
                rel="noopener noreferrer"
            >
                {{ kycVerificationLink }}
            </a>
            <div v-else class="kyc-modal-link-disabled">
                Verification link is not available yet. Please contact support.
            </div>
            <div class="kyc-modal-warning">
                Your card will remain temporarily blocked until verification is completed.
            </div>
        </div>
    </div>

    <!-- 交易明細右側抽屜面板 -->
    <TransactionDetailDrawer
        v-model="showTransactionModal"
        :detail="transactionDetail"
        :has-prev="hasPrevTransaction"
        :has-next="hasNextTransaction"
        @prev="goToPrevTransaction"
        @next="goToNextTransaction"
    />
</template>

<script setup>
import { ref, nextTick, onMounted, onBeforeUnmount, defineProps, computed, watch } from 'vue'
import Datepicker1 from '@vuepic/vue-datepicker';
import Swal from 'sweetalert2';
import '@vuepic/vue-datepicker/dist/main.css';

import { useCardStore } from '@/store/driver/card';
import TransactionDetailDrawer from '@/components/driver/TransactionDetailDrawer.vue';
import { mapCardTransactionListItem, toTransactionDetail } from '@/utils/cardTransactionDetail';

const props = defineProps({
  verificationStatus: {
    type: String,
    default: 'blocked'
  }
})

// 初始化 card store
const cardStore = useCardStore()

// 計算屬性：根據卡片狀態控制開關
const cardStatus = computed(() => cardStore.cardInfo?.status)

// 計算屬性：判斷是否因為未驗證且餘額過高而需要禁用
const isDisabledDueToUnverified = computed(() => {
  const balance = parseFloat(cardStore.cardInfo?.balance) || 0
  const isCompliant = cardStore.cardInfo?.is_compliant
  return balance >= 1000 && isCompliant === false
})
const cardClosed = computed(() => {
  return cardStatus.value === 'closed'
})
// 計算屬性：判斷 temporarily lock card 開關是否應該禁用
const isLockCardDisabled = computed(() => {
  return cardStatus.value === 'lost_or_stolen' || deactivateCard.value === true || isDisabledDueToUnverified.value || cardStatus.value === 'closed'
})

// 計算屬性：判斷 lost/stolen 開關是否應該禁用
const isLostStolenDisabled = computed(() => {
  return cardStatus.value === 'inactive' || isDisabledDueToUnverified.value || cardStatus.value === 'closed'
})

// 計算屬性：根據卡片狀態設置 temporarily lock card 的初始狀態
const shouldLockCardBeOn = computed(() => {
  return cardStatus.value === 'inactive'
})


const lockCard = ref(false)
const deactivateCard = ref(false)
const showPopover = ref(false)
const popoverType = ref('lock')
const popoverRef = ref(null)
const showKycModal = ref(false)
const hasShownKycModal = ref(false)

function extractKycLink(payload) {
  if (!payload) return ''
  if (typeof payload === 'string') return payload
  if (typeof payload !== 'object') return ''

  const directLink = payload.link || payload.url || payload.kyc_url || payload.verification_url || payload.manual_kyc_url
  if (directLink && typeof directLink === 'string') return directLink

  for (const value of Object.values(payload)) {
    const nestedLink = extractKycLink(value)
    if (nestedLink) return nestedLink
  }

  return ''
}

const kycVerificationLink = computed(() => {
  return extractKycLink(cardStore.kycStatus)
})

// Transaction history data - 預設為當月1號到31號
const today = new Date()
const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0)
const dateFrom = ref(firstDayOfMonth)
const dateTo = ref(lastDayOfMonth)
const transactions = ref([])

// 交易明細抽屜面板
const showTransactionModal = ref(false)
const selectedTransactionIndex = ref(-1)
const transactionDetail = ref({
  merchant: '',
  amount: '',
  date: '',
  time: '',
  cardType: '',
  paymentStatus: '',
  reference: ''
})

const hasPrevTransaction = computed(() => selectedTransactionIndex.value > 0)
const hasNextTransaction = computed(() => (
  selectedTransactionIndex.value >= 0 &&
  selectedTransactionIndex.value < transactions.value.length - 1
))

function setTransactionDetail(index) {
  const transaction = transactions.value[index]
  if (!transaction) return

  selectedTransactionIndex.value = index
  transactionDetail.value = toTransactionDetail(transaction, {
    showCardType: true
  })
}

function openTransactionDetail(transaction) {
  const index = transactions.value.findIndex((item) => item.id === transaction.id)
  if (index === -1) return

  setTransactionDetail(index)
  showTransactionModal.value = true
}

function goToPrevTransaction() {
  if (!hasPrevTransaction.value) return
  setTransactionDetail(selectedTransactionIndex.value - 1)
}

function goToNextTransaction() {
  if (!hasNextTransaction.value) return
  setTransactionDetail(selectedTransactionIndex.value + 1)
}

// 日期選擇器限制：今天往前算180天
const maxDate = computed(() => {
  return new Date() // 今天
})

const minDate = computed(() => {
  const minDate = new Date()
  minDate.setDate(minDate.getDate() - 180) // 往前算180天
  return minDate
})

// 分頁相關變數
const currentPage = ref(1)
const pageInput = ref(1)
const paginationMeta = ref({
  total_pages: 1,
  total_items: 0
})

// 分頁計算屬性
const pagination = computed(() => {
  // 使用後端分頁大小（20筆）
  const pageSize = 20
  const totalPages = parseInt(paginationMeta.value?.total_pages) || 1
  const totalItems = parseInt(paginationMeta.value?.total_items) || 0
  const current = parseInt(currentPage.value) || 1
  
  // 確保 current 是有效的數字
  const validCurrent = Math.max(1, Math.min(current, totalPages))
  
  const startItem = Math.max(1, (validCurrent - 1) * pageSize + 1)
  const endItem = Math.min(validCurrent * pageSize, totalItems)
  
  return {
    currentPage: validCurrent,
    totalPages: Math.max(1, totalPages),
    totalItems: Math.max(0, totalItems),
    pageSize,
    startItem: Math.max(1, startItem),
    endItem: Math.max(0, endItem)
  }
})

const shouldPromptKyc = computed(() => {
  return isDisabledDueToUnverified.value
})

function closeKycModal() {
  showKycModal.value = false
}

async function searchTransactions(page = 1) {
  try {
    // 準備查詢參數 - 使用後端分頁
    const searchParams = {
      from: formatDateForAPI(dateFrom.value),
      to: formatDateForAPI(dateTo.value),
      page: page
    }
    
    
    const response = await cardStore.getCradTransaction(searchParams)
    
   
    
    // 使用後端分頁資訊
    if (response?.transactions && Array.isArray(response.transactions)) {
      // 更新分頁資訊（使用後端返回的 meta）
      const newTotalPages = parseInt(response.meta?.total_pages) || 1
      const newTotalItems = parseInt(response.meta?.total_items) || 0
      
      // 如果返回的頁數或項目數為0，但我們有交易數據，保持之前的值
      if (newTotalPages === 1 && newTotalItems === 0 && response.transactions.length > 0) {
      
        // 不更新 paginationMeta，保持之前的值
      } else {
        paginationMeta.value = {
          total_pages: newTotalPages,
          total_items: newTotalItems
        }
      }
      
      currentPage.value = page
      pageInput.value = page
      
      
      
      transactions.value = response.transactions.map(mapCardTransactionListItem)
      
      
    } else {
      
      // 沒有資料時，重置分頁資訊
      paginationMeta.value = {
        total_pages: 1,
        total_items: 0
      }
      currentPage.value = 1
      pageInput.value = 1
      transactions.value = []
    }
  } catch (error) {
   
  }
}

// 分頁導航函數
async function goToPage(page) {
  try {
    // 確保 pagination 存在且有效
    if (!pagination.value) {
      console.warn('分頁資料尚未載入')
      return
    }
    
    // 驗證頁碼範圍
    const targetPage = Math.max(1, Math.min(page, pagination.value.totalPages))
    
    if (targetPage === currentPage.value) {
      return // 如果已經是目標頁面，不需要重新載入
    }
    
   
    
    // 重新調用 API 獲取指定頁面的數據
    await searchTransactions(targetPage)
  } catch (error) {
    console.error('分頁跳轉失敗:', error)
  }
}

function changPin() {
  window.open('https://pin.emerchants.com.au/', '_blank')
}

// 格式化日期為 API 需要的格式 (YYYY-MM-DD)
function formatDateForAPI(date) {
  if (!date) return ''
  const d = new Date(date)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

// 格式化日期為顯示格式 (DD/MM/YY)
function formatDateForDisplay(dateString) {
  if (!dateString) return ''
  const date = new Date(dateString)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = String(date.getFullYear()).slice(-2)
  return `${day}/${month}/${year}`
}

async function onSwitch(type, event) {
  if (type === 'lock') {
    if (lockCard.value) {
      // 開→關，解鎖卡片，顯示提示窗
      event.preventDefault()
      popoverType.value = 'unlock'
      showPopover.value = true
      nextTick(() => { if (popoverRef.value) popoverRef.value.focus() })
    } else {
      // 關→開，彈窗確認鎖定
      event.preventDefault()
      popoverType.value = type
      showPopover.value = true
      nextTick(() => { if (popoverRef.value) popoverRef.value.focus() })
    }
  } else if (type === 'deactivate') {
    event.preventDefault()
    if (deactivateCard.value) {
      // 開→關，移除 lost/stolen 狀態，顯示移除提示窗
      popoverType.value = 'remove-lost-stolen'
      showPopover.value = true
      nextTick(() => { if (popoverRef.value) popoverRef.value.focus() })
    } else {
      // 關→開，標記為 lost/stolen，顯示標記提示窗
      popoverType.value = type
      showPopover.value = true
      nextTick(() => { if (popoverRef.value) popoverRef.value.focus() })
    }
  }
}
async function confirmSwitch() {
  showPopover.value = false
  try {
    if (popoverType.value === 'lock') {
      lockCard.value = true
      await cardStore.lockCard('lock')  // 鎖定卡片
      // 重新載入卡片資訊以更新狀態
      await cardStore.fetchCardInfo()
    } else if (popoverType.value === 'unlock') {
      // 解鎖卡片
      lockCard.value = false
      await cardStore.activateCard(cardStore.cardInfo?.external_account_id)  // 解鎖卡片
      // 重新載入卡片資訊以更新狀態
      await cardStore.fetchCardInfo()
    } else if (popoverType.value === 'deactivate') {
      // 標記為 lost/stolen（開關關閉，要開啟）
      deactivateCard.value = true
      await cardStore.lostCard()  // 標記為遺失卡片
      // 重新載入卡片資訊以更新狀態
      await cardStore.fetchCardInfo()
    } else if (popoverType.value === 'remove-lost-stolen') {
      // 移除 lost/stolen 狀態（開關已開啟，要關閉）
      deactivateCard.value = false
      await cardStore.activateCard(cardStore.cardInfo?.external_account_id)  // 重新激活卡片
      // 重新載入卡片資訊以更新狀態
      await cardStore.fetchCardInfo()
    }
  } catch (error) {
    console.error('Error performing card action:', error)
    // 如果操作失敗，恢復開關狀態
    if (popoverType.value === 'deactivate') {
      deactivateCard.value = false
    } else if (popoverType.value === 'remove-lost-stolen') {
      deactivateCard.value = true
    }
  }
}

function showDeactivatePopover() {
  popoverType.value = 'deactivate-cancel'
  showPopover.value = true
  nextTick(() => { if (popoverRef.value) popoverRef.value.focus() })
}

async function confirmDeactivateCancel() {
  showPopover.value = false
  try {
    Swal.fire({
      title: 'This action is permanent. Once deactivated, this card cannot be used again.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Permanently deactivate',
      cancelButtonText: 'Cancel'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await cardStore.lockCard('closed')
          // 重新載入卡片資訊
          await cardStore.fetchCardInfo()
          
          // 顯示成功訊息
          Swal.fire({
            title: 'Success',
            text: 'Card has been permanently deactivated',
            icon: 'success',
            confirmButtonText: 'OK'
          })
        } catch (error) {
          console.error('Error deactivating card:', error)
          // 顯示錯誤訊息
          Swal.fire({
            title: 'Error',
            text: error.message || 'Failed to deactivate card',
            icon: 'error',
            confirmButtonText: 'OK'
          })
        }
      }
    })
  } catch (error) {
    console.error('Error calling deactivate:', error)
  }
}
function cancelSwitch() {
  showPopover.value = false
}

// 激活卡片的方法
async function activateCard(EAID) {
  try {
    await cardStore.activateCard(EAID)
    // 重新載入卡片資訊以更新狀態
    await cardStore.fetchCardInfo()
  } catch (error) {
    console.error('Error activating card:', error)
  }
}

// 監聽卡片狀態變化，自動更新開關狀態
watch(cardStatus, (newStatus) => {
  
  
  // 根據新狀態更新開關
  if (newStatus === 'inactive') {
    lockCard.value = true
    deactivateCard.value = false
  } else if (newStatus === 'lost_or_stolen') {
    lockCard.value = false
    deactivateCard.value = true
  } else if (newStatus === 'active') {
    lockCard.value = false
    deactivateCard.value = false
  }
  
  
}, { immediate: true })

watch(
  shouldPromptKyc,
  (shouldShow) => {
    if (shouldShow && !hasShownKycModal.value) {
      showKycModal.value = true
      hasShownKycModal.value = true
      return
    }

    if (!shouldShow) {
      showKycModal.value = false
      hasShownKycModal.value = false
    }
  },
  { immediate: true }
)

function handleKeydown(e) {
  if (showPopover.value && e.key === 'Escape') {
    cancelSwitch()
  }
}
onMounted(async () => {
  window.addEventListener('keydown', handleKeydown)
  
  // 載入卡片資訊
  try {
    await cardStore.fetchCardInfo()
    await cardStore.getKYCStatus()
  
    
    // 根據卡片狀態設置開關初始狀態
    if (cardStore.cardInfo?.status === 'inactive') {
      lockCard.value = true  // inactive 狀態時，temporarily lock card 應該是開啟的
    } else if (cardStore.cardInfo?.status === 'lost_or_stolen') {
      deactivateCard.value = true  // lost_or_stolen 狀態時，lost/stolen 應該是開啟的
    }
    
    
    
    // 載入交易記錄
    
    await searchTransactions()
  } catch (error) {
    console.error('Failed to load card info:', error)
  }
})
onBeforeUnmount(() => {
  window.removeEventListener('keydown', handleKeydown)
})
</script>

<style scoped>
.small-card-img {
    max-width: 220px;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.card-number {
    margin-top: 25px;
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
    color: #051C2C;
}

.left-text {
    margin-top: 20px;
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #051C2C;
}

.card-balance-amount {
    margin-top: 10px;
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 600;
    font-size: 42px;
    line-height: 53px;
    color: #051C2C;
}

.card-verification-status {
    margin-top: 10px;
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
}

.status-verified {
    color: #00c962;
}

.status-blocked {
    color: #FF4040;
}

.blocked-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    color: #e53935;
    font-size: 18px;
    border: 2px solid #e53935;
    margin-right: 10px;
}

.unverified-text {
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 19px;
    color: #051C2C;
}

.btn-verify {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 14px 32px;
    gap: 10px;
    max-width: 198px;
    height: 46px;
    border: 2px solid #00C962;
    border-radius: 30px;
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 23px;
    color: #051C2C;
}
.btn-Apply-new-card {
  box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 14px 32px;
    gap: 10px;
    
    height: 46px;
    border: 2px solid #00C962;
    border-radius: 30px;
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 23px;
    color: #051C2C;
}
.btn-Apply-new-card:hover {
  background: #00C962;
  color: #fff;
}

.btn-verify:hover {
    background: #00C962;
    color: #fff;
}

.external-link {
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    display: flex;
    align-items: center;
    margin-left: 10px;
    color: #5E707D;
}

.switch-row {
    display: flex;
    flex-direction: column;
    gap: 18px;
}
.custom-switch-group {
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
    min-height: 32px;
}
.custom-switch {
    position: relative;
    display: inline-flex;
    align-items: center;
    width: 44px;
    height: 24px;
    vertical-align: middle;
}
.custom-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}
.custom-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    border: 2px solid #22313f;
    border-radius: 24px;
    transition: .2s;
}
.custom-slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 2px;
    bottom: 2px;
    background-color: #22313f;
    border-radius: 50%;
    transition: .2s;
}
.custom-slider.checked {
    border: 2px solid #e53935;
    background: #fff;
}
.custom-slider.checked:before {
    background-color: #e53935;
    left: 22px;
}
/* 禁用狀態的樣式 */
.custom-switch input:disabled ~ .custom-slider {
    cursor: not-allowed;
    background: #f5f5f5;
    border: 2px solid #d0d0d0;
    opacity: 0.6;
}
.custom-switch input:disabled ~ .custom-slider:before {
    background-color: #d0d0d0;
}
.custom-switch input:disabled ~ .custom-slider.checked {
    border: 2px solid #f5a9a9;
    background: #f5f5f5;
}
.custom-switch input:disabled ~ .custom-slider.checked:before {
    background-color: #f5a9a9;
}
.custom-switch-group:has(input:disabled) .switch-label {
    color: #999;
    opacity: 0.6;
}
.switch-label {
    font-family: 'Mulish';
    font-size: 16px;
    color: #22313f;
    vertical-align: middle;
    display: flex;
    align-items: center;
    height: 24px;
    margin-left: 6px;
}
.switch-popover-mask {
    position: absolute;
    left: 60px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2000;
    pointer-events: all;
}
.switch-popover {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.12);
    border: 2px solid #a398f7;
    padding: 24px 32px 20px 32px;
    min-width: 400px;
    max-width: 90vw;
    text-align: left;
    outline: none;
    pointer-events: all;
}
.popover-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #22313f;
    margin-bottom: 12px;
    font-family: 'Euclid Square', sans-serif;
}
.popover-desc {
    color: #22313f;
    font-size: 1rem;
    margin-bottom: 24px;
    font-family: 'Mulish', sans-serif;
}
.popover-actions {
    display: flex;
    justify-content: flex-end;
    gap: 32px;
}
.btn-link.text-secondary {
    color: #b0b7c3;
    font-weight: 500;
    font-size: 1rem;
    background: none;
    border: none;
    cursor: pointer;
}
.btn-link.text-primary {
    color: #a398f7;
    font-weight: 600;
    font-size: 1rem;
    background: none;
    border: none;
    cursor: pointer;
}

/* Transaction History Styles */
.transaction-history {
    padding: 10px;
}

.transaction-title {
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 30px;
    color: #051C2C;
    margin-bottom: 10px;
}

.transaction-note {
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #666;
    margin-bottom: 20px;
}

.search-section {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    align-items: end;
    margin-bottom: 24px;
}

.date-filters {
    display: flex;
    gap: 10px;
}

.filter-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 280px;
}

.filter-group label {
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #051C2C;
}

.search-btn {
    width: 150px;
    height: 46px;
    background: #00C962;
    border-radius: 30px; 
    border: none;
    margin-bottom: 3px;
    color: black;
}

.search-btn:hover {
    background: #00a34f;
    color: black;
}

.table-container {
    overflow-x: auto;
    margin-top: 20px;
}

.transaction-table {
    width: 100%;
    border-collapse: collapse;
    font-family: 'Mulish';
    border: none;
}

.transaction-table th {
    background: none;
    font-family: 'Mulish';
    font-weight: 600;
    font-size: 16px;
    color: #051C2C;
    padding: 15px 20px;
    text-align: left;
    border-bottom: 1px solid #E5E5E5;
    border-top: none;
    border-left: none;
    border-right: none;
}

.transaction-table td {
    padding: 15px 20px;
    font-family: 'Mulish';
    font-size: 16px;
    color: #051C2C;
    border-bottom: 1px solid #F0F0F0;
    border-top: none;
    border-left: none;
    border-right: none;
}

.transaction-table tr:hover {
    background: none;
}

.money-in {
    color: #00C962 !important;
    font-weight: 600;
}

.money-out {
    color: #FF4040 !important;
    font-weight: 600;
}

/* Info 欄 */
.info-col {
    width: 60px;
    text-align: center !important;
}

.transaction-info-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    background: none;
    color: #5b4cff;
    cursor: pointer;
    transition: transform 0.15s;
}

.transaction-info-btn:hover {
    transform: translateX(2px);
}

.deactivate-cancel-container {
    position: relative;
    margin-top: 20px;
}

.btn-deactivate-cancel {
    background: none;
    border: none;
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    color: black;
    text-decoration: underline;
    cursor: pointer;
    padding: 0;
}

.deactivate-popover-mask {
    position: absolute;
    left: 0;
    top: 30px;
    z-index: 2000;
    pointer-events: all;
}

.no-transactions {
    text-align: center;
    padding: 40px 20px;
    color: #666;
    font-style: italic;
}

.no-transactions p {
    margin: 0;
    font-size: 16px;
}

tbody .no-transactions {
    padding: 20px;
}



@media (max-width: 1600px) {
    
    .btn-verify {
      width: 160px;
      font-size: 12px;
    }

    .external-link {
        font-size: 12px;
    }
    .search-btn{
        margin-left: 15px;
    }
}

/* 分頁控制項樣式 */
.pagination-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    padding: 15px;
    background-color:#EEF1F4;
    border-radius: 8px;
    overflow-x: auto;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.arrow-icon {
  width: 28px;
  height: 28px;
}

.rotate-180 {
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}

.pagination-btn:not(:disabled):hover .rotate-180 {
  transform: rotate(180deg) scale(1.1);
}

.pagination-controls {
    display: flex;
    align-items: center;
    gap: 10px;
}

.pagination-btn {
    width: 32px;
    height: 32px;
    background: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    flex-shrink: 0;
    padding: 0;
}

.pagination-btn:not(:disabled) img {
    filter: brightness(0) saturate(100%) invert(33%) sepia(95%) saturate(2000%) hue-rotate(240deg) brightness(0.95) contrast(1.1);
}

.pagination-btn:not(:disabled):hover img {
    filter: brightness(0) saturate(100%) invert(33%) sepia(95%) saturate(2000%) hue-rotate(240deg) brightness(0.95) contrast(1.1);
    transform: scale(1.1);
}

.pagination-btn:not(:disabled):hover .rotate-180 {
    transform: rotate(180deg) scale(1.1);
}

.pagination-btn:disabled img {
    filter: brightness(0) saturate(100%) invert(60%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(95%) contrast(88%);
    cursor: not-allowed;
    opacity: 0.6;
}

.pagination-btn i {
    font-size: 14px;
    color: #666;
}

.pagination-btn:hover:not(:disabled) i {
    color: #00C962;
}

.page-input-container {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 15px;
}

.page-label {
    font-size: 12px;
    color: #495057;
    white-space: nowrap;
    font-weight: 500;
}

.page-input {
    width: 40px;
    height: 28px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    text-align: center;
    font-size: 12px;
    background-color: white;
    color: #495057;
    padding: 0 5px;
}

.page-input:focus {
    outline: none;
    border-color: #00C962;
    box-shadow: 0 0 0 2px rgba(0, 201, 98, 0.1);
}

.page-total {
    font-size: 12px;
    color: #495057;
    white-space: nowrap;
    font-weight: 500;
}

.pagination-info {
    text-align: center;
    font-size: 12px;
    color: #495057;
    flex-shrink: 0;
    white-space: nowrap;
    margin-top: 10px;
    font-weight: 500;
}

/* 響應式設計 */
@media (max-width: 768px) {
    .pagination-container {
        flex-direction: column;
        gap: 15px;
        align-items: center;
    }
    
    .pagination-controls {
        order: 2;
    }
    
    .pagination-info {
        order: 1;
    }
    
    .page-input-container {
        margin: 0 10px;
    }
}

/* 自定義 Bootstrap 覆蓋樣式 - 移除 .row > * 的左右 padding */
.row > * {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.kyc-modal-mask {
    position: fixed;
    inset: 0;
    background: rgba(5, 28, 44, 0.45);
    z-index: 5000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.kyc-modal {
    width: 100%;
    max-width: 1000px;
    background: #fff;
    border-radius: 14px;
    padding: 28px 40px;
    text-align: center;
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.22);
}

.kyc-modal-title {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-family: 'Euclid Square';
    font-size: 28px;
    line-height: 1.2;
    font-weight: 600;
    color: #051C2C;
    margin-bottom: 18px;
}

.kyc-alert-icon {
    width: 26px;
    height: 26px;
}

.kyc-modal-text {
    font-family: 'Mulish';
    font-size: 20px;
    line-height: 1.2;
    color: #051C2C;
}

.kyc-modal-link {
    display: inline-block;
    margin-top: 20px;
    font-family: 'Mulish';
    font-size: 20px;
    line-height: 1.2;
    color: #3f56ff;
    text-decoration: underline;
    word-break: break-all;
}

.kyc-modal-link-disabled {
    margin-top: 20px;
    font-family: 'Mulish';
    font-size: 24px;
    line-height: 1.2;
    color: #5E707D;
}

.kyc-modal-warning {
    margin-top: 20px;
    font-family: 'Mulish';
    font-size:20px;
    line-height: 1.2;
    color: #ff4040;
}

@media (max-width: 992px) {
    .kyc-modal {
        padding: 20px;
    }

    .kyc-modal-title {
        font-size: 28px;
    }

    .kyc-modal-text,
    .kyc-modal-link,
    .kyc-modal-warning,
    .kyc-modal-link-disabled {
        font-size: 22px;
    }
}

</style>